"use client";

import Link from "next/link";
import HeaderAuth from "../auth/header-auth";

export default function Header() {
  return (
    <header className="sticky top-0 z-40 flex items-center justify-between border-b bg-background/80 px-12 py-4 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="text-2xl ml-5 font-bold text-neutral-700 cursor-pointer">
        <Link href="/">Guide by Smart Algorhythm</Link>
      </div>
      <HeaderAuth />
    </header>
  );
}
